import { Routes } from '@angular/router';

import { AccueilComponent } from './accueil/accueil.component';

import { PageComponent } from './page/page.component';
import { PermissionDeniedComponent } from './del-common/components/permission-denied/permission-denied.component';
import { StatistiquesComponent } from './statistiques/statistiques.component';
import {FeedbackComponent} from './common/components/feedback/feedback.component';
import {AuthGuardService} from '../common/core/services/auth/auth-guard.service';


export const ROUTES: Routes = [
  // Wiki P8 est priv�  (TG-103): toute route demande une connexion
  // une route qui aurait besoin d'�tre publique serait en dehors de ce parent
  {
    path: '',
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      { path: '', component: AccueilComponent },
      { path: 'page/:id', component: PageComponent},
      { path: 'feedback', component: FeedbackComponent},
      { path: 'statistiques', component: StatistiquesComponent},
      { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
      { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)},
    ]
  },
  { path: 'forbidden', component: PermissionDeniedComponent},
];
